// JsFromEnums CacheKey 7aa1fefbb8d40eb4fa7388af57379848
//
// DO NOT MODIFY: This file was automatically generated by JsFromEnums.
export const COLUMN_LITHIC = {
  "min": 15,
  "max": 19,
  "label": "15-19 business days"
}

export const PERFECT_GIFT = {
  "min": 10,
  "max": 14,
  "label": "10-14 business days"
}
